//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { createFragmentContainer } from "react-relay";
// suggestion-body-week-in-review imports
import { IContainer, IProps, IState } from "./SuggestionBodyWeekInReview.d";
import { suggestionBodyWeekInReviewFragments } from "./SuggestionBodyWeekInReview.gql";
import * as s from "./SuggestionBodyWeekInReview.styles";
// other components
import { WeekInReviewScrubber } from "@components/week-in-review-scrubber";

//////////////////
// COMPONENT
//////////////////
class SuggestionBodyWeekInReviewCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }
  public render() {
    return (
      <div style={s.container}>
        <WeekInReviewScrubber
          rewindHistory={this.props.suggestionPayload.rewindHistory}
          rewindWeek={this.props.suggestionPayload.rewindWeek}
        />
      </div>
    );
  }
}

//////////////////
// RELAY
//////////////////
export const SuggestionBodyWeekInReview = createFragmentContainer<IContainer>(
  SuggestionBodyWeekInReviewCmpt,
  suggestionBodyWeekInReviewFragments,
);
